module.exports = __webpack_public_path__ + "img/content-bundles.e724111f.jpg";